import RepoApiRequest from '../../utils/bcc-repo-api-request';
import endpoints from '../repo-api-endpoints';

const read = async (code) => {
  try {
    const result = await RepoApiRequest({ url: endpoints.announcements.get(code) });
    // console.log(result);
    return result;
  } catch (err) {
    console.error("Error getting page data", err);
    return null;
  }
  // return result;
}

const announcementsRepository = { read };

export { read }
export default announcementsRepository
